import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const branchCourseList = createAsyncThunk('branchCourseList', async ({ pageable: data, navigate, status, instituteBranchId, instituteId, branchUserId }) => {
    try {
        const byBranchUser = instituteId && branchUserId
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + (byBranchUser ? 'course_by_branch_user' : `branch_course?status=${status || ''}`),
            params: byBranchUser ? {
                institute_id: instituteId,
                branch_user_id: branchUserId,
                pageNo: data?.currentPage ?? 0,
                pageSize: data?.pageSize ?? 10,
                ...(data?.search ? { search: data.search } : {}),
            } : {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                ...(instituteBranchId ? { institute_branch_id: instituteBranchId } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) { return error.response
    }
})

const branchCourseListSlice = createSlice({ name: 'branchCourseList',
    initialState: { data: [] },
    extraReducers: (builder) => { builder.addCase(branchCourseList.fulfilled, (state, action) => { if (action?.payload?.status === 200) { state.data = (() => { const raw = action.payload.data.data; return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []); })();
            } else if (action?.payload?.status === 401) { showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) { showAccessDeniedAlert(action.meta.arg.navigate)
            } else { state.data = []
            }
        });
    }
})

export default branchCourseListSlice.reducer;
